<template>
    <b-container fluid class="bv-example-row">
        <b-modal id="bv-modal-create-new-configuration" hide-footer :visible="showModal" @close="hide" @hidden="hide"
            :no-close-on-backdrop="isBusy" :no-close-on-esc="isBusy" :hide-header-close="isBusy"
            header-bg-variant="dark" header-text-variant="light" body-bg-variant="dark" body-text-variant="light">
            <template v-slot:modal-title>{{$t('create_configuration')}}</template>
            <div v-if="loadError" class="text-danger template-load-error">
                {{$t('template_create_load_error')}}
                <b-button class="template-load-retry" type="button" :disabled="loadingTypes" @click="loadTypes">{{$t('retry')}}</b-button>
            </div>
            <div v-else-if="!loadingTypes && !deviceTypeList.length">{{$t('empty_list')}}</div>
            <b-form @submit.prevent="onSubmit">
                <fieldset :disabled="isBusy || loadingTypes">
                    <b-form-group :label="$t('device_configuration.create.name') + ':'" label-for="input-name">
                        <b-form-input id="input-name" v-model="data.name" required />
                    </b-form-group>
                    <b-form-group :label="$t('device_configuration.create.description') + ':'" label-for="input-description">
                        <b-form-input id="input-description" v-model="data.description" required />
                    </b-form-group>
                    <div class="text-muted">{{$t('template_create_limits')}}</div>
                    <b-form-group :label="$t('device_configuration.create.type') + ':'" label-for="input-deviceTypeId">
                        <b-form-select id="input-deviceTypeId" :options="deviceTypeList" value-field="id" text-field="name"
                            v-model="data.deviceTypeId" required />
                    </b-form-group>
                    <div v-if="responseError" class="text-danger template-create-error">{{$t('template_create_error')}}</div>
                    <b-button :disabled="!canSubmit()" type="submit" variant="primary">{{$t('device_configuration.create.create')}}</b-button>
                </fieldset>
            </b-form>
        </b-modal>
    </b-container>
</template>

<script>
    import axios from "axios";
    import router from "../../router";
    import { REQUEST_TIMEOUT_MS } from "../../utils/RequestGuard";

    const validText = (value, max) => typeof value === 'string' && value.trim().length > 0 && Array.from(value).length <= max;
    const validId = value => Number.isInteger(value) && value > 0 && value <= 999999999999999;

    export default {
        name: "Create",
        data() {
            return {
                showModal: false, isBusy: false, loadingTypes: true, loadError: false, responseError: false,
                disposed: false, readRequest: 0, deviceTypeList: [],
                data: { deviceTypeId: null, description: null, name: null },
            };
        },
        beforeDestroy() { this.disposed = true; this.readRequest++; },
        methods: {
            show() { if (!this.disposed) { this.responseError = false; this.showModal = true; } },
            hide() { if (!this.isBusy) this.showModal = false; },
            canSubmit() {
                return !this.disposed && !this.isBusy && !this.loadingTypes && !this.loadError
                    && validText(this.data.name, 50) && validText(this.data.description, 250)
                    && validId(this.data.deviceTypeId) && this.deviceTypeList.some(item => item.id === this.data.deviceTypeId);
            },
            async loadTypes() {
                if (this.disposed) return;
                const request = ++this.readRequest;
                this.loadingTypes = true; this.loadError = false; this.deviceTypeList = [];
                try {
                    const response = await axios.get('api/v1/devices/device-types', { timeout: REQUEST_TIMEOUT_MS });
                    if (this.disposed || request !== this.readRequest) return;
                    if (!Array.isArray(response.data.rows)) throw new Error('Invalid device type list');
                    this.deviceTypeList = response.data.rows.filter(item => validId(item?.id));
                } catch (error) {
                    if (!this.disposed && request === this.readRequest && error.response?.status !== 401) this.loadError = true;
                } finally { if (!this.disposed && request === this.readRequest) this.loadingTypes = false; }
            },
            async onSubmit() {
                if (!this.canSubmit()) return;
                const type = this.data.deviceTypeId;
                const payload = { name: this.data.name, description: this.data.description };
                this.isBusy = true; this.responseError = false;
                try {
                    const response = await axios.post('api/v1/saved-configurations/new/device-types/' + type, payload, {
                        timeout: REQUEST_TIMEOUT_MS, headers: { 'Content-type': 'application/json' },
                    });
                    if (!validId(response.data?.id)) throw new Error('Missing saved template id');
                    if (this.disposed) return;
                    this.showModal = false;
                    await router.push({ name: 'savedConfiguration', params: { id: response.data.id } });
                } catch (error) {
                    if (!this.disposed && error.response?.status !== 401) this.responseError = true;
                } finally { if (!this.disposed) this.isBusy = false; }
            },
        },
        mounted() { this.loadTypes(); },
    };
</script>

<style scoped>
</style>
